export const ACCOUNT_TYPE_FOR_BANK = {
  ToThePublic: 1,
  ToThePrivate: 2,
};

export const ACCOUNT_TYPE_FOR_BANK_DESC = {
  [ACCOUNT_TYPE_FOR_BANK.ToThePublic]: '对公账户',
  [ACCOUNT_TYPE_FOR_BANK.ToThePrivate]: '对私账户',
};

export const CERTIFICATE_TYPE = {
  IdCard: 101,
  BusinessLicense: 200,
  IndividualBusiness: 201,
  PubicInstitution: 202,
};

export const CERTIFICATE_TYPE_DESC = {
  [CERTIFICATE_TYPE.IdCard]: '身份证',
  [CERTIFICATE_TYPE.BusinessLicense]: '企业营业执照/统一社会信用代码',
  [CERTIFICATE_TYPE.IndividualBusiness]: '企业营业执照/统一社会信用代码', //  应该是个体工商户，但是现在后端及其他段显示有问题 暂时统一显示为“企业营业执照/统一社会信用代码”
  [CERTIFICATE_TYPE.PubicInstitution]: '事业单位法人证书',
};

export const SIGNER_TYPE = {
  Individual: 1,
  Enterprise: 2,
  Agent: 3,
};

export const WALLET_STATUS = {
  WaitToInput: 0, //  待录入
  ValidateFail: 1, //  未生效，验卡失败
  CreateSuccess: 2,
  WaitToConfirm: 3,
  Refused: 4,
  CreateFailure: 5,
  AUDITING: 6, // 审核中
  AUDIT_REJECT: 7, // 审核失败
};

export const QUALIFICATION_TYPE = {
  IdCard: 101,
  ChinesePassport: 103,
  MainlandTravelPermitFormHkAndMo: 105, // 港澳通行证
  MainlandTravelPermitFormTw: 106, // 台湾通行证
  Passport: 108,
  BusinessLicense: 200, // 企业法人资质/营业执照
  IndividualBusiness: 201, // 个体工商户
  PubicInstitution: 202, // 事业单位法人证书
};
